import financial from '@/http/financial';
import { captureError } from '@/Utils/Sentry/captureErrorSentry';

/**
 * Module Structure
 */
const state = {
  isLoadingChart: false,
  chartData: {},
  lastPrice: 0,
  time: 0,
  variationNominal: 0,
  variationPercent: 0,
  lastProfitabilityFiveDays: 0,
  lastProfitabilityLastYear: 0,
  dataFormattedChart: [],
};

const getters = {
  isLoadingChart: (state) => state.isLoadingChart,
  getChartData: (state) => state.chartData,
  getLastPrice: (state) => state.lastPrice,
  getTime: (state) => state.time,
  getVariationNominal: (state) => state.variationNominal,
  getVariationPercent: (state) => state.variationPercent,
  getLastProfitabilityFiveDays: (state) => state.lastProfitabilityFiveDays,
  getLastProfitabilityLastYear: (state) => state.lastProfitabilityLastYear,
  getDataFormattedChart: (state) => state.dataFormattedChart,
};

const mutations = {
  CLEAR_STATE(state) {
    state.isLoadingChart = false;
    state.chartData = {};
    state.lastPrice = 0;
    state.time = 0;
    state.variationNominal = 0;
    state.variationPercent = 0;
    state.lastProfitabilityFiveDays = 0;
    state.lastProfitabilityLastYear = 0;
    state.dataFormattedChart = [];
  },
  SET_IS_LOADING_CHART(state, isLoadingChart) {
    state.isLoadingChart = isLoadingChart;
  },
  SET_CHART_DATA(state, data) {
    state.chartData = data;
  },
  SET_LAST_PRICE(state, data) {
    state.lastPrice = data;
  },
  SET_TIME(state, data) {
    state.time = data;
  },
  SET_VARIATION_NOMINAL(state, data) {
    state.variationNominal = data;
  },
  SET_VARIATION_PERCENT(state, data) {
    state.variationPercent = data;
  },
  SET_PROFITABILITY_FIVE_DAYS(state, data) {
    state.lastProfitabilityFiveDays = data;
  },
  SET_PROFITABILITY_LAST_YEAR(state, data) {
    state.lastProfitabilityLastYear = data;
  },
  SET_DATA_FORMATTED_CHART(state, data) {
    state.dataFormattedChart = data;
  },
};

const actions = {
  async fetchChartData({ commit }, { tickerId } = {}) {
    try {
      const ticker = tickerId.toUpperCase().trim();
      const response = await financial.get(`${ticker}`);
      commit('SET_CHART_DATA', response.data);
    } catch (error) {
      captureError(error, 'error');
      throw error?.response?.data;
    }
  },

  async clearState({ commit }) {
    commit('CLEAR_STATE');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
